export function parentsHasClass (el: Element, cls: string) {
  if (el.classList.contains(cls)) {
    return true;
  }
  if (el.parentElement) {
    return parentsHasClass(el.parentElement, cls);
  }
  return false;
}

export function parentIsButton (el: Element) {
  if (el.tagName === 'BUTTON') {
    return true;
  }
  if (el.parentElement) {
    return parentIsButton(el.parentElement);
  }
  return false;
}